var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSomeLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.586 2.448a2 2 0 012.828 0l14.678 14.678a2 2 0 010 2.828L19.414 34.632a2 2 0 01-2.828 0L1.908 19.954a2 2 0 010-2.828L16.586 2.448z",
    stroke: "#595CB9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#595CB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M18 21V11"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.125,
    transform: "matrix(1 0 0 -1 18 25)",
    fill: "#595CB9",
    stroke: "#595CB9",
    strokeWidth: 0.25
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzNiAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjU4NTggMi40NDc5NEMxNy4zNjY5IDEuNjY2ODkgMTguNjMzMiAxLjY2Njg5IDE5LjQxNDIgMi40NDc5NEwzNC4wOTE5IDE3LjEyNTZDMzQuODczIDE3LjkwNjcgMzQuODczIDE5LjE3MyAzNC4wOTE5IDE5Ljk1NDFMMTkuNDE0MiAzNC42MzE3QzE4LjYzMzIgMzUuNDEyOCAxNy4zNjY5IDM1LjQxMjggMTYuNTg1OCAzNC42MzE4TDEuOTA4MTEgMTkuOTU0MUMxLjEyNzA2IDE5LjE3MyAxLjEyNzA2IDE3LjkwNjcgMS45MDgxMSAxNy4xMjU2TDE2LjU4NTggMi40NDc5NFoiIHN0cm9rZT0iIzU5NUNCOSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHgxPSIxIiB5MT0iLTEiIHgyPSIxMSIgeTI9Ii0xIiB0cmFuc2Zvcm09Im1hdHJpeCg0LjM3MTE0ZS0wOCAtMSAtMSAtNC4zNzExNGUtMDggMTcgMjIpIiBzdHJva2U9IiM1OTVDQjkiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxjaXJjbGUgcj0iMS4xMjUiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDE4IDI1KSIgZmlsbD0iIzU5NUNCOSIgc3Ryb2tlPSIjNTk1Q0I5IiBzdHJva2Utd2lkdGg9IjAuMjUiLz4KPC9zdmc+Cg==";
export { SvgSomeLine as ReactComponent };